/**
 * open and close types
 */
export const OPEN_SOCIAL_POPUP = 'OPEN_SOCIAL_POPUP';
export const CLOSE_SOCIAL_POPUP = 'CLOSE_SOCIAL_POPUP';
export const OPEN_NESTED_SOCIAL_POPUP = 'OPEN_NESTED_SOCIAL_POPUP';
export const OPEN_OVERLAY_SOCIAL_POPUP = 'OPEN_OVERLAY_SOCIAL_POPUP';
export const CLOSE_OVERLAY_SOCIAL_POPUP = 'CLOSE_OVERLAY_SOCIAL_POPUP';